export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


export const addId = (item: any) => ({id: guid(), ...item});


export const findCentroid = (points: Array<{ lat: number, lng: number}>) =>
  points.reduce((accum, point) => {
    return {
      lat: accum.lat + point.lat / points.length,
      lng: accum.lng + point.lng / points.length,
    };
  }, { lat: 0, lng: 0});


// WEBPACK FOOTER //
// ./src/utils/utils.tsx